<template>
  <sui-page>
    <sui-page-header title="현황 조회" />
    <sui-page-contents>
      <div class="comm_title_wrap">
        <!-- 기본정보 -->
        <h4>{{ $t('MSG_TIT_DEFAULT_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <!-- 제목 -->
            <sui-input-label :label="$t('MSG_TIT_TTL')" />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ approvalTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <!-- 작성자 -->
            <sui-input-label :label="$t('MSG_TIT_DOC_CRTR')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ drafterSummary }}
            </div>
          </div>
          <div class="col-xs-1">
            <!-- 작성일시 -->
            <sui-input-label :label="$t('MSG_TIT_DRAT_DTM')" />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ approvalDraftDTM }}
            </div>
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <!-- 결재 정보 -->
        <h4>{{ $t('MSG_TIT_APRV_INFO') }}</h4>
      </div>
      <div
        class="width100"
        style="flex-direction:row"
      >
        <cmp-user-select
          ref="user"
          class="mrB05 width100"
          @selected="onSelectedUser"
        />
        <cmp-approval-list-manager
          ref="approvalManager"
          :pageId="contextPageId"
          :emailFieldName="'approvalUserEmail'"
          :approverDispFormat="approverDispFormat"
        />
      </div>
    </sui-page-contents>
    <!-- Page Footer -->
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <!-- 취소 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel"
        >
          {{ $t("MSG_BTN_CNCL") }}
        </sui-button>
        <!-- 적용 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickApply"
        >
          {{ $t('MSG_BTN_APPLY') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

// 결재라인 을 DB 에 insert 하기 위해 꼭 필요한 필드 정보들 정의
// validation check
const USER_COLUMNS_FOR_SAVE = [
  { columnName: 'approvalDepartmentEnglishName', required: false },
  { columnName: 'approvalDepartmentName', required: false },
  { columnName: 'approvalDepartmentId', required: false },
  { columnName: 'approvalOrder', required: true }, // 결재순서
  { columnName: 'approvalParallelOrder', required: true }, // 결재병렬순서
  { columnName: 'approvalUserEmail', required: true },
  { columnName: 'approvalUserGlobalName', required: true },
  { columnName: 'approvalUserId', required: true },
  { columnName: 'approvalUserName', required: true }, // 결재사용자명
  { columnName: 'rightApprovalTypeCode', required: true }, // 결재권유형코드
  { columnName: 'rightApprovalTypeStateCode', required: true }, // 결재권유형상태코드
  { columnName: 'userDisplayLanguageId', required: true },
];

const USER_PROPS_FOR_APPEND = [
  'approvalDepartmentDispName',
  'approvalDepartmentEnglishName',
  'approvalDepartmentName',
  'approvalDepartmentId',
  // 'approvalUserCareerLevelCode',
  // 'approvalUserCareerLevelDispName',
  // 'approvalUserCareerLevelEnglishName',
  // 'approvalUserCareerLevelName',
  'approvalUserDispName',
  'approvalUserEmail',
  'approvalUserGlobalName',
  'approvalUserId',
  'approvalUserName',
];

export default {
  name: 'PGE_CML_00009', // eslint-disable-line vue/name-property-casing
  filters: {
    /**
     * 
     */
    dateformatToClient(value) {
      const result = utils.dateformatToClient(value);
      return utils.isDate(result) ? result : '-';
    },
  },
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: true,
      default() {
        return {
          approvalUid: '',
          approvalUserList: [],
        };
      },
    },
  },
  data() {
    return {
      approvalTitle: '',
      approvalDraftDTM: '', // 작성일시
      drafterSummary: '',
      approverDispFormat: '${approvalUserDispName}/${approvalUserCareerLevelDispName}/${approvalDepartmentDispName}/${approvalUserEmail}', // eslint-disable-line
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {
    if (utils.getConfigurationValue('CFG_CML_CHG_APRV_LINE') !== 'Y') {
      // '경로변경을 허용하지 않습니다(환경설정).'
      utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NPMSN_APRV_LINE_CHG'), () => {
        this.closePagePopup();
      });
    } else {
      // approvalUid 로 기존 데이터 조회
      // this.getApprovalByApprovalUid();
      this.setApprovalUserList();
      // 결재진행상태코드 와 결재진행상태코드명 목록 조회
      this.getApprovalTypeCodeName();
      // this.loadData();
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  created() {
    this.COD_APRVRT_TYPE = [];
  },
  destroyed() {},
  methods: {
    /**
     * 결재선 추가
     */
    async appendApprover(userInfoObj) {
      const userInfo = utils.clone(userInfoObj);
      userInfo.approvalDepartmentDispName = this.getDisplayText(userInfoObj.dsplLngId, userInfoObj.departmentName, userInfoObj.departmentEnglishName);
      userInfo.approvalDepartmentEnglishName = userInfoObj.departmentEnglishName;
      userInfo.approvalDepartmentId = userInfoObj.departmentId;
      userInfo.approvalDepartmentName = userInfoObj.departmentName;
      userInfo.approvalUserCareerLevelCode = userInfoObj.careerLevelCode;
      userInfo.approvalUserCareerLevelDispName = this.getDisplayText(userInfoObj.dsplLngId, userInfoObj.careerLevelName, userInfoObj.careerLevelEnName);
      userInfo.approvalUserCareerLevelEnglishName = userInfoObj.careerLevelEnName;
      userInfo.approvalUserCareerLevelName = userInfoObj.careerLevelName;
      userInfo.approvalUserDispName = this.getDisplayText(userInfoObj.dsplLngId, userInfoObj.userName, userInfoObj.userGlobalName);
      userInfo.approvalUserEmail = userInfoObj.email;
      userInfo.approvalUserGlobalName = userInfoObj.userGlobalName;
      userInfo.approvalUserId = userInfoObj.userId;
      userInfo.approvalUserName = userInfoObj.userName;
      userInfo.userDisplayLanguageId = userInfoObj.dsplLngId;

      const result = await this.validateUserForAppend(userInfo);
      if (result === true) {
        this.$refs.approvalManager.addApprover(userInfo);
      } else {
        // this.closePagePopup();
      }
    },
    /**
     * 결재선 변경 confirm
     */
    confirmApprovalLineChange() {
      return new Promise(resolve => {
        // "적용하시겠습니까?"
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_WANT_APPY'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    /**
     * approvalUid 로 결재상세 데이터 조회
     */
    getApprovalByApprovalUid() {
      http.request(this.contextPageId, 'DTS_CML_00004', {
        path: {
          'approval-uid': this.pageInitialData.approvalUid,
        },
      }).then(res => {
        this.approvalTitle = res.data.approvalTitle;
        // 작성자
        const drafter = utils.find(res.data.approvalUserList, { approvalOrder: 0 });
        this.drafterSummary = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}(${drafter.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)}`;
        this.approvalDraftDTM = utils.dateformatToClient(res.data.approvalDraftDTM);
        this.setApprovalLine(res.data.approvalUserList);
      });
    },
    /**
     * 결재진행상태코드 와 결재진행상태코드명 목록 조회
     */
    getApprovalTypeCodeName() {
      http.request(this.contextPageId, 'DTS_CMZ_00001', {
        path: { 'code-id': 'COD_APRVRT_TYPE' },
      }).then(res => {
        this.COD_APRVRT_TYPE = res.data;
      });
    },
    /**
     * 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
     */
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    /**
     * '적용' 버튼 click event handler
     */
    async onClickApply() {
      let isValid = true;
      /*
      실제 저장이 아니므로 confirm 은 주석 처리
      let isValid = await this.confirmApprovalLineChange();
      if (!isValid) return false;
      */
      isValid = await this.validateApprovalLineChange();
      if (!isValid) return false;

      // validate approval user columns in approval line for save
      const approvalLineList = this.$refs.approvalManager.getApprovalPathList();
      for (let i = 0; i < approvalLineList.length; i += 1) {
        const approvalUser = approvalLineList[i];
        // '결재사용자상세' 테이블의 '결재권유형상태코드' 값 추가
        utils.set(approvalUser, 'rightApprovalTypeStateCode', `${approvalUser.rightApprovalTypeCode}0`);

        // 결재조회 화면 자료구조로 추가
        // '역할'
        const rightApprovalTypeCodeObj = utils.find(this.COD_APRVRT_TYPE, { codeId: `${approvalUser.approvalType}` });
        utils.set(approvalUser, 'rightApprovalTypeCodeName', rightApprovalTypeCodeObj.codeName);
        // '의견'
        utils.set(approvalUser, 'approvalOpinionContent', '');
        // '처리일시'
        utils.set(approvalUser, 'approvalDTM', '');

        isValid = await this.validateUserForSave(approvalUser);
        if (!isValid) break;
      }
      if (!isValid) return false;


      this.closePagePopup({
        isChanged: true,
        approvalLineList,
      });
      return true;
    },
    /**
     * '취소' 버튼 click event handler
     */
    onClickCancel() {
      this.closePagePopup('');
    },
    // 사용자 검색 후 enter event handler
    onSelectedUser(objUser) {
      if (objUser && objUser.userId !== null) {
        this.appendApprover(objUser);
        this.$refs.user.reset();
      }
    },
    /**
     * 결재선 관리 컴포넌트에 결재선 추가하기
     */
    setApprovalLine(approvalUserList) {
      // 기안자부터 login user 까지 disabled = true 값 셋팅
      const loginUserIndex = utils.findIndex(approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });
      const loginUser = utils.find(approvalUserList, { approvalUserId: this.$store.getters.userInfo.userId });

      // login user and login user 와 동일한 병렬순서를 가진 user 까지는 disabled = true 로 설정되어야 함
      utils.forEach(approvalUserList, (user, index) => {
        utils.set(user, 'disabled', index <= loginUserIndex || user.approvalParallelOrder == loginUser.approvalParallelOrder);
        utils.set(user, 'approvalDepartmentDispName', this.getDisplayText(user.userDisplayLanguageId, user.approvalDepartmentName, user.approvalDepartmentEnglishName));
        utils.set(user, 'approvalUserCareerLevelDispName', this.getDisplayText(user.userDisplayLanguageId, user.approvalUserCareerLevelName, user.approvalUserCareerLevelEnglishName));
        utils.set(user, 'approvalUserDispName', this.getDisplayText(user.userDisplayLanguageId, user.approvalUserName, user.approvalUserGlobalName));
        utils.set(user, 'userDisplayLanguageId', user.userDisplayLanguageId);
        utils.set(user, 'knoxApprovalOrder', user.approvalParallelOrder);
        utils.set(user, 'approvalType', user.rightApprovalTypeCode);
        if (user.approvalOrder == 0) {
          this.$refs.approvalManager.setDrafter(user);
        } else {
          this.$refs.approvalManager.addApprover(user);
        }
      });
    },
    /**
     * 부모 페이지에서 prop으로 전달된 approvalUserList 를 컴포넌트 자료구조로 변환해서 추가
     */
    setApprovalUserList() {
      this.approvalTitle = this.pageInitialData.approvalTitle;
      // 작성자
      const drafter = utils.find(this.pageInitialData.approvalUserList, { approvalOrder: 0 });
      this.drafterSummary = `${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalUserName, drafter.approvalUserGlobalName)}(${drafter.approvalUserEmail.replace(/@.+/, '')}) / ${this.getDisplayText(drafter.userDisplayLanguageId, drafter.approvalDepartmentName, drafter.approvalDepartmentEnglishName)}`;
      this.approvalDraftDTM = this.pageInitialData.approvalDraftDTM;
      this.setApprovalLine(this.pageInitialData.approvalUserList);
    },
    /**
     * '결재선변경' 에 필요한 조건인지 검사
     * 결재선에 기안자 + '(병렬)결재' 나 '(병렬)합의' 최소 1 이상 존재해야 함
     */
    validateApprovalLineChange() {
      return new Promise(resolve => {
        const approvalLineList = this.$refs.approvalManager.getApprovalPathList();

        // '기안자' 존재 check
        if (utils.findIndex(approvalLineList, { approvalType: 0 }) === -1
          && utils.findIndex(approvalLineList, { approvalType: '0' }) === -1) {
          // 기안자가 필요합니다.
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NEED_DRFT'));
          resolve(false);
        }

        // '결재자' 혹은 '합의자'가 존재하는지 check
        let isApproverExist = false;
        utils.forEach(approvalLineList, user => {
          if (utils.indexOf([1, 2, 4, 7, '1', '2', '4', '7'], user.approvalType) >= 0) {
            isApproverExist = true;
          }
        });
        if (!isApproverExist) {
        // '결재자 혹은 합의자가 필요합니다.'
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_NEED_APRV_OR_AGRM'));
          resolve(false);
        }

        resolve(true);
      });
    },
    /**
     * 결재선 관리 컴포넌트에 추가하기 위한 property 확인
     */
    validateUserForAppend(userInfoObj) {
      return new Promise(resolve => {
        let errorProp = '';
        utils.forEach(USER_PROPS_FOR_APPEND, prop => {
          if (!Object.prototype.hasOwnProperty.call(userInfoObj, prop) || utils.isEmpty(userInfoObj[prop])) {
            errorProp = prop;
            return false;
          }
          return true;
        });

        if (!utils.isEmpty(errorProp)) {
          // TODO: message 등록
          utils.messageBox('warning', '결재선 정보 확인', `결재선 정보 중 '${errorProp}' 값이 누락되었습니다.`, () => {
            resolve(`결재선 정보 중 '${errorProp}' 값이 누락되었습니다.`);
            // don't use reject: await will throws that reject like a exception and immediately stop the progress
          });
        } else {
          resolve(true);
        }
      });
    },
    /**
     * 결재라인을 DB 에 저장하기 위해 필요한 필드 정보 확인
     */
    validateUserForSave(approvalUser = {}) {
      return new Promise(resolve => {
        let errorColumn = '';
        utils.forEach(USER_COLUMNS_FOR_SAVE, column => {
          if (column.required
            && (!Object.prototype.hasOwnProperty.call(approvalUser, column.columnName)
            || _.isNil(approvalUser[column.columnName]) || utils.trim(approvalUser[column.columnName]) === '')) {
            errorColumn = column.columnName;
            return false;
          }
        });

        if (!utils.isEmpty(errorColumn)) {
          // TODO: 메시지 등록
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), `[${errorColumn}] 값이 없습니다.`, () => {
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
<style scoped>
</style>
